module.exports = __webpack_public_path__ + "img/ico_voucher.6290e051.svg";